import React, { memo } from 'react';
import {
  FormGroup,
  Table as MuiTable,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { MenuRequisitionProps, MenuRequisitionItem } from '../../../../types/adminInterface';
import './table.scss';

const AdminMenuRequisitionTable: React.FC<MenuRequisitionProps> = ({
  data,
  handleMenuRequisition,
  modulename
}) => {
  return (
    <FormGroup className="table-wrapper AdminMenuRequisitionTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 425 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>User Role</TableCell>
              <TableCell>Days before {modulename} can be done</TableCell>
              <TableCell>Cut-off Time (HH:MM)</TableCell>
              <TableCell>Alert Email Notification (in mins)</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row: MenuRequisitionItem, index: number) => (
              <TableRow key={`${row.userrolename}-${index}`}>
                <TableCell>{index + 1}</TableCell>

                <TableCell>
                  <input type="text" placeholder="" value={row.userrolename} disabled />
                </TableCell>
                <TableCell>
                  <input
                    type="number"
                    placeholder=""
                    value={row.cuttoffday ?? ''}
                    onChange={(e) => handleMenuRequisition(index, 'cuttoffday', e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <div className="time-wrapper flex align-items-center">
                    <input
                      type="number"
                      placeholder="HH"
                      value={row.cutofftimehh ?? ''}
                      onChange={(e) =>
                        handleMenuRequisition(index, 'cutofftimehh', e.target.value)
                      }
                    />
                    <span>:</span>
                    <input
                      type="number"
                      placeholder="MM"
                      value={row.cutofftimemm ?? ''}
                      onChange={(e) =>
                        handleMenuRequisition(index, 'cutofftimemm', e.target.value)
                      }
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <div className='minutes flex align-items-center'>
                    <input
                      type="number"
                      value={row.alertnotificationminutes ?? ''}
                      onChange={(e) =>
                        handleMenuRequisition(index, 'alertnotificationminutes', e.target.value)
                      }
                    />
                    <span> minutes</span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </FormGroup>
  );
};

export default memo(AdminMenuRequisitionTable);
